// extracted by mini-css-extract-plugin
export default {"answersList":"v_bN"};